import React, { Component } from "react";
import { Link } from "react-router-dom";
import { ContainerWrapper, FlexLeft } from "../Utils";
import logo from "../../Images/logos/logo.png";
import "../Utils/index.css";
import "./index.css";




export default class Navbar extends Component {
  render() {
    return (
      <header className="App-header">
        <ContainerWrapper>
          <nav className="w-100 navbar d-flex nav__row--2 pt-3">
            <FlexLeft className="navbar__logo w-100">
              <Link to="/">
                <img src={logo} alt="GERS - Grow early, rapidly and securely"/>
              </Link>
            </FlexLeft>
          </nav>
        </ContainerWrapper>
      </header>  
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/Header/Nav.js